"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionsForValidCountries = exports.getCountryOptions = void 0;

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _getCountryName = _interopRequireDefault(require("./getCountryName"));

var _sortOptions = _interopRequireDefault(require("./sortOptions"));

var _CountryFlag = _interopRequireDefault(require("../components/CountryFlag"));

var allCountryOptions = [];

var getCountriesByCode = function getCountriesByCode() {
  // Should return uppercase language codes and their translations
  return _I18n.default.text('SharedI18nStrings.countryCodes');
};

var buildCountryOption = function buildCountryOption(countryCode) {
  var iso2 = countryCode.toLowerCase();
  return {
    text: (0, _getCountryName.default)(iso2),
    value: iso2,
    avatar: _react.default.createElement(_CountryFlag.default, {
      countryCode: iso2
    })
  };
};

var getCountryOptions = function getCountryOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      optionsFilter = _ref.optionsFilter;

  if (!optionsFilter && allCountryOptions.length) {
    return allCountryOptions;
  } else if (optionsFilter && allCountryOptions.length) {
    return allCountryOptions.filter(optionsFilter);
  }

  allCountryOptions = Object.keys(getCountriesByCode()).map(function (code) {
    return buildCountryOption(code);
  }).sort(_sortOptions.default);

  if (optionsFilter) {
    return allCountryOptions.filter(optionsFilter);
  }

  return allCountryOptions;
};

exports.getCountryOptions = getCountryOptions;

var getOptionsForValidCountries = function getOptionsForValidCountries(_ref2) {
  var validCountries = _ref2.validCountries,
      optionsFilter = _ref2.optionsFilter;
  var options = [];
  var countriesByCode = getCountriesByCode();
  validCountries.forEach(function (countryCode) {
    if (countriesByCode[countryCode.toUpperCase()]) {
      options.push(buildCountryOption(countryCode));
    }
  });

  if (optionsFilter) {
    options = options.filter(optionsFilter);
  }

  return options.sort(_sortOptions.default);
};

exports.getOptionsForValidCountries = getOptionsForValidCountries;